import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'api/queryClient';
import { showPendingSessionNotice } from 'api/mutator';
//import { configureFakeBackend } from'helpers';
import'@fortawesome/fontawesome-free/css/all.min.css';
import'assets/scss/Saas.scss';
import'styles/index.css';
import'assets/css/style.css';
import'assets/css/loading.css';
//import ReactGA from'react-ga4';
import { ToastContainer } from"react-toastify";

import { BrowserRouter } from'react-router-dom';
import { AllRoutes } from'Routes/Routes';
import FloatingButton from 'components/AiAssistant/FloatingButton';



//ReactGA.initialize('G-DTZXQ1XXF4');

const App = () => {
    //configureFakeBackend();

    //? Aviso de sessão expirada deixado pelo mutator antes de recarregar para /login
    useEffect(() => {
        showPendingSessionNotice();
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter future={{ 
                v7_startTransition: true, v7_relativeSplatPath: true 
            }}>
                <AllRoutes />
                {/* Assistente de IA em qualquer tela do escritório (spec ai-assistant-06) */}
                <FloatingButton />
            </BrowserRouter>
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar={true}
                pauseOnHover
                theme="light"
            />
        </QueryClientProvider>
    );
};

export default App;
